import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const creatSQLConfig = createAsyncThunk('setupSlice/creatSQLConfig', async (values) => {
  try {
    const response = await axios.post(`Setup/connectDatabase`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const creatADdomainConfig = createAsyncThunk('setupSlice/creatADdomainConfig', async (values) => {
  try {
    const response = await axios.post(`Setup/createDomain`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const getDomainDetails = createAsyncThunk('setupSlice/getDomainDetails', async () => {
  try {
    const response = await axios.get(`Setup/getdomaindetails`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response?.status, data: err.response?.data };
  }
});
export const creatADgroupConfig = createAsyncThunk('setupSlice/creatADgroupConfig', async (values) => {
  try {
    const response = await axios.put(`Setup/createadmingroups?id=${values.id}`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const getAllDomainGroups = createAsyncThunk('setupSlice/getAllDomainGroups', async (value) => {
  try {
    const response = await axios.get(`Setup/getalldomaingroups?FQDN=${value}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response?.status, data: err.response?.data };
  }
});
export const setupActivateLicense = createAsyncThunk('setupSlice/setupActivateLicense', async (values) => {
  try {
    const response = await axios.post(`/Setup/setupactivatelicense`, values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const setupGetLicenseDetails = createAsyncThunk('setupSlice/setupGetLicenseDetails', async () => {
  try {
    const response = await axios.get(`/Setup/setupgetlicense`);
    return response.data;
  } catch (err) {
    return null;
  }
});
export const getLicenseTier = createAsyncThunk('setupSlice/getLicenseTier', async (value) => {
  try {
    const response = await axios.get(
      `/Setup/getTierInfoApi?productCode=${value.productCode}&productKey=${encodeURIComponent(value.licenseKey)}&email=${value.email}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response?.status, data: err.response?.data };
  }
});
export const setupStatus = createAsyncThunk('setupSlice/setupStatus', async () => {
  try {
    const response = await axios.get(`Setup/setup_status`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response?.status, data: { domainstatus: false, groupstatus: false } };
  }
});
export const setupMaildelivery = createAsyncThunk('setupSlice/setupMaildelivery', async (value) => {
  try {
    const response = await axios.put('/maildelivery', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
export const setupTestMicrosoft = createAsyncThunk('setupSlice/setupTestMicrosoft', async (value) => {
  try {
    const response = await axios.post('/office365testmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
export const setupTestStandard = createAsyncThunk('setupSlice/setupTestStandard', async (value) => {
  try {
    const response = await axios.post('/Smtptestmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
export const setupTestGmail = createAsyncThunk('setupSlice/setupTestGmail', async (value) => {
  try {
    const response = await axios.post('/testgmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
export const setupUploadGmailFile = createAsyncThunk('setupSlice/setupUploadGmailFile', async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`/Upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    return err.message;
  }
});

const initialState = {
  current: 0,
  progress: 0,
  status: 'process',
  loading: false,
  domainData: null,
  groupsData: [],
  error: null,
  setUpStatus: null,
};

const setupSlice = createSlice({
  name: 'setupSlice',
  initialState,
  reducers: {
    setCurrent: (state, action) => { state.current = action.payload; },
    setStatus(state, action) { state.status = action.payload; },
    incrementProgress(state) { state.progress += 2; },
    resetProgress(state) { state.progress = 0; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatSQLConfig.pending, (state) => { state.progress = 0; state.loading = true; state.error = null; })
      .addCase(creatSQLConfig.fulfilled, (state) => { state.progress = 100; state.loading = false; })
      .addCase(creatSQLConfig.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(creatADdomainConfig.pending, (state) => { state.progress = 0; state.loading = true; state.error = null; })
      .addCase(creatADdomainConfig.fulfilled, (state) => { state.progress = 100; state.loading = false; })
      .addCase(creatADdomainConfig.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(getDomainDetails.fulfilled, (state, action) => { state.loading = false; state.domainData = action.payload.data; })
      .addCase(creatADgroupConfig.pending, (state) => { state.progress = 0; state.loading = true; state.error = null; })
      .addCase(creatADgroupConfig.fulfilled, (state) => { state.progress = 100; state.loading = false; })
      .addCase(creatADgroupConfig.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(getAllDomainGroups.fulfilled, (state, action) => { state.groupsData = action.payload.data; })
      .addCase(setupStatus.fulfilled, (state, action) => { state.loading = false; state.setUpStatus = action.payload.data; });
  },
});

export const { setCurrent, incrementProgress, setStatus, resetProgress } = setupSlice.actions;
export default setupSlice.reducer;
